import { render, staticRenderFns } from "./MyOrdersServicesHostingRepresentative.vue?vue&type=template&id=77f35155"
import script from "./MyOrdersServicesHostingRepresentative.vue?vue&type=script&lang=js"
export * from "./MyOrdersServicesHostingRepresentative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports